import { useEffect, useState } from "react";
import { apiService } from "../../constants/ApiService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SaveExcelExportTblConfig = () => {
    const navigate = useNavigate();
    const location = useLocation()
  const [form, setForm] = useState({
    id:null,
    tbl_name: "",
    display_name: "",
    description: "",
    module_name: "",
    is_active: 1,
    columns: [
      { column_name: "", column_position: 1 }
    ]
  });
  

  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    if(location.state){
       // setForm(location.state)
        fetchById(location.state.id);
    }
  }, [location.state]);

  // 🔹 handle normal inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // 🔹 handle column change
  const handleColumnChange = (index, field, value) => {
    const cols = [...form.columns];
    cols[index][field] = value;
    setForm({ ...form, columns: cols });
  };

  // 🔹 add column
  const addColumn = () => {
    setForm({
      ...form,
      columns: [
        ...form.columns,
        {
          column_name: "",
          column_position: form.columns.length + 1
        }
      ]
    });
  };

  // 🔹 remove column
  const removeColumn = (index) => {
    const cols = form.columns.filter((_, i) => i !== index);
    cols.forEach((c, i) => (c.column_position = i + 1));
    setForm({ ...form, columns: cols });
  };

  // 🔹 submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
    //   const fd = new FormData();

    //   if (form.id) fd.append("id", form.id);

    //   fd.append("tbl_name", form.tbl_name);
    //   fd.append("display_name", form.display_name);
    //   fd.append("description", form.description);
    //   fd.append("module_name", form.module_name);
    //   fd.append("is_active", form.is_active);

    //   // 🔑 IMPORTANT
    //   fd.append("columns", JSON.stringify(form.columns));

      const res = await apiService.post(
        "/api/ExcelExportConfiguration/SaveExportTable",
        form
      );

      if(res.status){
        toast.success(res.message || "Saved successfully");
        navigate("/GetExcelExportTblConfig");
      }else{
        toast.error(res.message || "Failed to save");
      }


     // if (onSuccess) onSuccess(res.data);
    } catch (err) {
      console.error(err);
      alert(
        err?.response?.data?.Message ||
        "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  //getbyId
    const fetchById = async (id) => {
      setLoading(true);
  
      try {
        const res = await apiService.get(
          "/api/ExcelExportConfiguration/GetExportTableById?id=" + id,
        );
        if (res.status) {
          console.log(res);
            const resP = res.parent;
            const resC = res.exportHeaders;
          setForm({ ...resP, columns: resC });
        } else {
          alert(res.message);
        }
      } catch (err) {
        console.error(err);
        alert("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

  return(
  <>
  
        <div className='text-right mb-2'>
          <Link to="/GetExcelExportTblConfig" className='btn btn-secondary'>
            <i className='bi bi-arrow-left' /> Back
          </Link>
        </div>

    <form onSubmit={handleSubmit} className="card p-4 shadow-sm">

      <h5 className="mb-3">
        {form.id ? "Update Export Configuration for Tables" : "Create Export Configuration for Tables"}
      </h5>

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Table Name</label>
          <input
            type="text"
            className="form-control"
            name="tbl_name"
            value={form.tbl_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6">
          <label>Display Name</label>
          <input
            type="text"
            className="form-control"
            name="display_name"
            value={form.display_name}
            onChange={handleChange}
            required
          />
        </div>
      </div>

    

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Module Name</label>
          <input
            type="text"
            className="form-control"
            name="module_name"
            value={form.module_name}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <label>Status</label>
          <select
            className="form-control"
            name="is_active"
            value={form.is_active}
            onChange={handleChange}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>
          <div className="col-md-12 mb-3">
        <label>Description</label>
         <input
            type="text"
          className="form-control"
          name="description"
          value={form.description}
          onChange={handleChange}
        />
      </div>
      </div>

      <hr />

      <h6>Columns</h6>

      {form?.columns?.map((col, index) => (
        <div className="row mb-2" key={index}>
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Column Name"
              value={col.column_name}
              onChange={(e) =>
                handleColumnChange(index, "column_name", e.target.value)
              }
              required
            />
          </div>

          <div className="col-md-3">
            <input
              type="number"
              className="form-control"
              value={col.column_position}
              readOnly
            />
          </div>

          <div className="col-md-3">
            <button
              type="button"
              className="btn btn-danger w-100"
              onClick={() => removeColumn(index)}
              disabled={form.columns.length === 1}
            >
              <i className="fa fa-trash"></i> Remove
            </button>
          </div>
        </div>
      ))}

<div className="text-right">
  <button
    type="button"
    className="btn btn-secondary mb-3"
        onClick={addColumn}
  >
    + Add More Columns
  </button>
</div>

      <br />

      <button
        type="submit"
        className="btn btn-primary"
        disabled={loading}
      >
       <i className="fa fa-check-circle"></i> {loading ? "Saving..." : "Save"}
      </button>

    </form>
  </>)
};

export default SaveExcelExportTblConfig;